import { Link, Icon } from 'anf-core-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import OneTrustModalLink from '../../Footer/OneTrustModalLink';
import styles from './menu.module.scss';

/**
 * MenuSelector renders either a nav link or a button to go to the next menu level
 *
 * @param {function} [props.onClick] - Function for navigating to the next menu level.
 * @param {string} [props.link] - URL for the link. If not provided, a button
 * will be rendered.
 * @param {React.ReactNode} props.children - Either the text of the link or an espot
 * @param {boolean} [props.isClearance] - Whether this is a clearance link (with
 * special styling).
 * @param {boolean} [props.isExternal] - Whether the link should open in a new tab.
 * @returns {JSX.Element} The rendered MenuSelector component.
 */
const MenuSelector = ({
  onClick = undefined,
  link = undefined,
  label = '',
  isClearance = false,
  theme = 'secondary',
  id,
  isExternal = false,
  children,
}) => {
  if (id === 'manageMyPreferences') {
    return (
      <OneTrustModalLink
        className={classNames(styles.link, styles.secondary)}
        link={{ link, title: label }}
      />
    );
  }

  return (
    <Link
      classList={classNames(
        styles.link,
        {
          [styles.clearance]: isClearance,
          [styles.secondary]: theme === 'secondary',
          [styles.primary]: theme === 'primary',
          [styles.tertiary]: theme === 'tertiary',
        },
      )}
      href={link}
      onClick={(!link && onClick) ? () => onClick(id, 'forward', label) : undefined}
      target={isExternal ? '_blank' : undefined}
    >
      <div className={styles.label}>
        <div>{children}</div>
        {(!link && onClick) ? (
          <div className={styles.icon}>
            <Icon
              icon="right-thin"
              label=""
              size="xs"
            />
          </div>
        ) : null}
      </div>
    </Link>
  );
};

MenuSelector.propTypes = {
  onClick: PropTypes.func,
  link: PropTypes.string,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isClearance: PropTypes.bool,
  isExternal: PropTypes.bool,
  label: PropTypes.string,
  theme: PropTypes.string,
};

export default MenuSelector;
